import MenuList from "@material-ui/core/MenuList";
import { alpha } from "@material-ui/core/styles";
import styled from "styled-components";

export const CustomMenuList = styled(MenuList)`
	> li:hover {
		background-color: ${props => alpha(props.theme.palette.background.paper, 0.08)};
	}
`;
